import React from "react";
import useApiEp from "../hooks/useApiEp";
import { Alert, Box, LinearProgress, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { getErrorResponse } from "../utils/util";

const SelectTemplate = ({ disabled = false, onSelect }) => {
  const { data, isLoading, isError, error } = useApiEp(
    `/api/get-templates-sync`
  );

  if (isLoading) {
    return <LinearProgress sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }} />;
  }

  if (isError) {
    return (
      <Alert severity="error" sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}>
        {getErrorResponse(error)}
      </Alert>
    );
  }
  const templates = data?.data || [];

  return (
    <Box my={2}>
      <Autocomplete
        size="small"
        disabled={disabled}
        options={templates}
        getOptionLabel={(option) => option.name || ""}
        onChange={(event, newValue) => {
          onSelect(newValue ? newValue.id : null);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Template"
            variant="outlined"
            placeholder="Search templates..."
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#ffffff",
                "& fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.3)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.5)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ffffff",
                },
              },
              "& .MuiInputLabel-root": {
                color: "rgba(255, 255, 255, 0.7)",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#ffffff",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "rgba(255, 255, 255, 0.5)",
              },
            }}
          />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        sx={{
          width: 300,
          "& .MuiAutocomplete-popper": {
            "& .MuiPaper-root": {
              bgcolor: "#1a472a", // Dark green background for dropdown
              color: "#ffffff",
            },
            "& .MuiAutocomplete-option": {
              "&:hover": {
                bgcolor: "rgba(255, 255, 255, 0.1)",
              },
              "&[aria-selected='true']": {
                bgcolor: "rgba(255, 255, 255, 0.2)",
              },
            },
          },
        }}
      />
    </Box>
  );
};

export default SelectTemplate;
